import H from 'constants/httpMethod.const';
import logger from 'utils/logger.util';
import actionEndpointBe from 'utils/mw/actionEndpointBe.util';

const L = logger('bePayInvoice'); // eslint-disable-line no-unused-vars

const fromDtoToInvoice = (dto) => ({
  invoiceId: dto?.invoice_id,
});

const fromTInvoiceToDto = (item) => ({
  invoice_id: item?.invoiceId,
});

export const bePayInvoiceRead = actionEndpointBe(
  'bePayInvoiceRead',
  H.get,
  'billing/:salonId/pay/invoice/',
  (options) => ({
    ...options,
    inert: true,
    fromDto: fromDtoToInvoice,
  }),
);

export const bePayInvoiceWrite = actionEndpointBe(
  'bePayInvoiceWrite',
  H.post,
  'billing/:salonId/pay/invoice/',
  (options, extra) => ({
    ...options,
    inert: true,
    fromDto: fromDtoToInvoice,
    toDto: fromTInvoiceToDto,
    data: extra?.data,
  }),
);
